import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
/**
 * Checkout class
 */

export class CheckoutModel extends BaseModel {
  constructor(...args) {
    super(...args);

    this.getDeliveryMethods = () => CheckoutModel.methodsToArray(this.model?.deliveryMethods ?? {});

    this.getPaymentMethods = () => CheckoutModel.methodsToArray(this.model?.paymentMethods ?? {});

    this.getDeliveryTime = () => this.model.deliveryTime;

    this.getDiscounts = () => this.model.discounts;

    this.getDiscountValue = () => this.model?.discounts?.points?.value ?? 0;

    this.getDiscountPoints = () => this.model?.discounts?.points?.pointsDiscount ?? 0;

    this.getProductsParams = () => this.model.productsParams;

    this.getTotalCount = () => this.model.totalCount;

    this.getTotalOriginalPrice = () => this.model.totalOriginalPrice;

    this.getTotalPrice = () => this.model.totalPrice;
  }

  /**
   * Create сheckout model
   *
   * @param {object} object
   *
   * @return {CheckoutModel}
   */
  static create(object) {
    return super.create(object);
  }
  /**
   * To convert {Methods} to [{label: 'Methods.key'}, {value: 'Methods.value'}, ...]
   *
   * @param {Object} methods
   *
   * @return {Array.<{label: string, value: string}>}
   */


}

CheckoutModel.methodsToArray = methods => Object.entries(methods).map(method => ({
  value: method[0],
  label: method[1]
}));